import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReturnMessage } from 'src/app/models/return-message';
import { ReturnDashboardItemPayload } from 'src/app/models/dashboard/return-dashboard-item-payload';
import { ReturnDashboardItemsPayload } from 'src/app/models/dashboard/return-dashboard-items-payload';
import { ReturnUserDashboardItemResultPayload } from 'src/app/models/dashboard/return-user-dashboard-item-result-payload';
import { ReturnDashboardItemSettingsPayload } from 'src/app/models/dashboard/return-dashboard-item-settings-payload';
import { PostDashboardItem } from 'src/app/models/dashboard/post-dashboard-item';

@Injectable({
  providedIn: 'root'
})
export class DashboardService 
{

  private apis = 
  {
    getUserDashboardItem: 'Dashboard/GetUserDashboardItem',
    getUserDashboardItems: 'Dashboard/GetUserDashboardItems',
    getUserDashboardItemResult: 'Dashboard/GetUserDashboardItemResult',
    getDashboardItemSettings: 'Dashboard/GetDashboardItemSettings',
    saveUserDashboardItem: 'Dashboard/SaveUserDashboardItem',
    reorderUserDashboardItem: 'Dashboard/ReorderUserDashboardItem',
    resetUserDashboardItems: 'Dashboard/ResetUserDashboardItems',
    deleteUserDashboardItem: 'Dashboard/DeleteUserDashboardItem',
    getDefaultDashboardItem: 'Dashboard/GetDefaultDashboardItem',
    getDefaultDashboardItems: 'Dashboard/GetDefaultDashboardItems',
    saveDefaultDashboardItem: 'Dashboard/SaveDefaultDashboardItem',
    reorderDefaultDashboardItem: 'Dashboard/ReorderDefaultDashboardItem',
    deleteDefaultDashboardItem: 'Dashboard/DeleteDefaultDashboardItem'
  };

  constructor(
    private http: HttpClient
  ) 
  {
  }

  getUserDashboardItem(userDashboardItemId: number): Observable<ReturnMessage<ReturnDashboardItemPayload>> 
  {
    const options = 
    {
      params: new HttpParams()
        .set('userDashboardItemId', userDashboardItemId)
    };
    return this.http.get<ReturnMessage<ReturnDashboardItemPayload>>(this.apis.getUserDashboardItem, options);
  }

  getUserDashboardItems(): Observable<ReturnMessage<ReturnDashboardItemsPayload>> 
  {
    return this.http.get<ReturnMessage<ReturnDashboardItemsPayload>>(this.apis.getUserDashboardItems);
  }

  getUserDashboardItemResult(userDashboardItemId: number, filteredUserId: number = null): Observable<ReturnMessage<ReturnUserDashboardItemResultPayload>> 
  {
    const options = 
    {
      params: new HttpParams()
        .set('userDashboardItemId', userDashboardItemId)
    };

    if (filteredUserId != null)
    {
      options.params = options.params.set('filteredUserId', filteredUserId)
    }
    return this.http.get<ReturnMessage<ReturnUserDashboardItemResultPayload>>(this.apis.getUserDashboardItemResult, options);
  }

  getDashboardItemSettings(): Observable<ReturnMessage<ReturnDashboardItemSettingsPayload>> 
  {
    return this.http.get<ReturnMessage<ReturnDashboardItemSettingsPayload>>(this.apis.getDashboardItemSettings);
  }

  saveUserDashboardItem(postDashboardItem: PostDashboardItem): Observable<ReturnMessage<any>> 
  {
    return this.http.post<ReturnMessage<any>>(this.apis.saveUserDashboardItem, postDashboardItem);
  }

  reorderUserDashboardItem(originalIndex: number, newIndex: number): Observable<ReturnMessage<any>> 
  {
    const options = 
    {
      params: new HttpParams()
        .set('originalIndex', originalIndex)
        .set('newIndex', newIndex)
    };
    return this.http.post<ReturnMessage<any>>(this.apis.reorderUserDashboardItem, null, options);
  }

  resetUserDashboardItems(): Observable<ReturnMessage<any>> 
  {
    const options = 
    {
      params: new HttpParams()
        .set('Content-Length', 0)
    };
    return this.http.post<ReturnMessage<any>>(this.apis.resetUserDashboardItems, null, options);
  }

  deleteUserDashboardItem(userDashboardItemId: number): Observable<ReturnMessage<any>> 
  {
    const options = 
    {
      params: new HttpParams()
        .set('userDashboardItemId', userDashboardItemId)
    };
    return this.http.delete<ReturnMessage<any>>(this.apis.deleteUserDashboardItem, options);
  }

  getDefaultDashboardItem(defaultDashboardItemId: number): Observable<ReturnMessage<ReturnDashboardItemPayload>> 
  {
    const options = 
    {
      params: new HttpParams()
        .set('defaultDashboardItemId', defaultDashboardItemId)
    };
    return this.http.get<ReturnMessage<ReturnDashboardItemPayload>>(this.apis.getDefaultDashboardItem, options);
  }

  getDefaultDashboardItems(): Observable<ReturnMessage<ReturnDashboardItemsPayload>> 
  {
    return this.http.get<ReturnMessage<ReturnDashboardItemsPayload>>(this.apis.getDefaultDashboardItems);
  }

  saveDefaultDashboardItem(postDashboardItem: PostDashboardItem): Observable<ReturnMessage<any>> 
  {
    return this.http.post<ReturnMessage<any>>(this.apis.saveDefaultDashboardItem, postDashboardItem);
  }

  reorderDefaultDashboardItem(originalIndex: number, newIndex: number): Observable<ReturnMessage<any>> 
  {
    const options = 
    {
      params: new HttpParams()
        .set('originalIndex', originalIndex)
        .set('newIndex', newIndex)
    };
    return this.http.post<ReturnMessage<any>>(this.apis.reorderDefaultDashboardItem, null, options);
  }

  deleteDefaultDashboardItem(defaultDashboardItemId: number): Observable<ReturnMessage<any>> 
  {
    const options = 
    {
      params: new HttpParams()
        .set('defaultDashboardItemId', defaultDashboardItemId)
    };
    return this.http.delete<ReturnMessage<any>>(this.apis.deleteDefaultDashboardItem, options);
  }
}
